module.exports = __webpack_public_path__ + "static/media/pen.05682bae.svg";